import React, { useState } from 'react';
import { Input, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import './style.scss';

interface IPasswordInput {
	value: string;
	placeholder: string;
	hasError?: boolean | string;
	errorMsg?: string;
	width?: number;
	disabled?: boolean;
	name: string;
	autoComplete?: string;
	onChange: (e: React.ChangeEvent<unknown>) => unknown;
	onBlur: (e: React.ChangeEvent<unknown>) => unknown;
}

export const PasswordInput: React.FC<IPasswordInput> = ({
	placeholder,
	hasError,
	errorMsg,
	disabled,
	...rest
}: IPasswordInput) => {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	return (
		<div className="InputRoot InputRoot--password">
			<div className="password-input-wrapper">
				<Input
					{...rest}
					fullWidth
					disableUnderline
					disabled={disabled}
					placeholder={placeholder}
					type={showPassword ? 'text' : 'password'}
					error={!!hasError}
					sx={{
						height: '40px',
						fontSize: '16px',
						color: '#8f8f8f',
						padding: '10px 28px 10px 10px',
						boxSizing: 'border-box',
						'& .MuiInput-input': {
							padding: 0,
						},
						'&:before': {
							border: 'none',
						},
						'&:after': {
							border: 'none',
						},
						'&:hover:not(.Mui-disabled):before': {
							border: 'none',
						},
					}}
				/>
				<IconButton
					className="password-toggle-btn"
					aria-label={showPassword ? 'hide the password' : 'display the password'}
					onClick={togglePasswordVisibility}
					size="small"
					disableRipple
					tabIndex={-1}
				>
					{showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
				</IconButton>
			</div>
			{hasError && <p className="InputErrorBox">{errorMsg}</p>}
		</div>
	);
};